namespace TabAurous.OMS {
    export interface TaxForm {
        GroupId: Serenity.LookupEditor;
        TaxType: Serenity.LookupEditor;
        TaxName: Serenity.StringEditor;
        Rate: Serenity.DecimalEditor;
        ApplicableOn: TaxEditor;
        CalculatingMode: TaxCalconEditor;
        Narration: Serenity.StringEditor;
        LedgerId: Serenity.LookupEditor;
        OutputLedgerId: Serenity.LookupEditor;
        InputRCMLedgerId: Serenity.LookupEditor;
        OutputRCMLedgerId: Serenity.LookupEditor;
        HasThreshold: Serenity.BooleanEditor;
        SingleTrans: Serenity.DecimalEditor;
        CumulativeTrans: Serenity.DecimalEditor;
        ProductType: Serenity.LookupEditor;
        IsDisabled: Serenity.BooleanEditor;
        ItemDetails: TaxDetailsEditor;
    }

    export class TaxForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.Tax';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TaxForm.init)  {
                TaxForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;
                var w3 = TaxEditor;
                var w4 = TaxCalconEditor;
                var w5 = s.BooleanEditor;
                var w6 = TaxDetailsEditor;

                Q.initFormType(TaxForm, [
                    'GroupId', w0,
                    'TaxType', w0,
                    'TaxName', w1,
                    'Rate', w2,
                    'ApplicableOn', w3,
                    'CalculatingMode', w4,
                    'Narration', w1,
                    'LedgerId', w0,
                    'OutputLedgerId', w0,
                    'InputRCMLedgerId', w0,
                    'OutputRCMLedgerId', w0,
                    'HasThreshold', w5,
                    'SingleTrans', w2,
                    'CumulativeTrans', w2,
                    'ProductType', w0,
                    'IsDisabled', w5,
                    'ItemDetails', w6
                ]);
            }
        }
    }
}
